import Commission from '__core/shared/model/commission/Commission';
import CommissionSplit from '__core/shared/model/commission/CommissionSplit';
import stCommissionEdit from './commissionEdit.component';
import commissionsController from './commissions.controller';
import stCommissionsList from './commissionsList.component';

export default angular
  .module('st.Commission', ['st.Core', 'angular-cache'])
  .factory('Commission', () => Commission)
  .factory('CommissionSplit', () => CommissionSplit)
  .component('stCommissionEdit', stCommissionEdit)
  .controller('commissionsController', commissionsController)
  .component('stCommissionsList', stCommissionsList)
  .service('commissionService', ($http, Commission, dataService, COMMISSION) => {
    const mergeGenerics = (
      splits,
      enterprise,
      group,
      organization,
      owner,
      partners,
      accountsAsPartners
    ) => {
      const output = [];
      const replaceGeneric = (split) => {
        const out = split;
        if (_.some(COMMISSION.PAYEE, (p) => p.id === out.idPayee)) {
          switch (out.idPayee) {
            case 'GEN_ORG_ENT':
              out.name = enterprise.organization.name;
              break;
            case 'GEN_ORG_GRP':
              out.name = group.organization.name;
              break;
            case 'GEN_ORG_BRN':
            case 'GEN_ORG_CUR':
              out.name = organization.organization.name;
              break;
            case 'GEN_ORG_LS1':
              out.name = organization.organization.licenses.in1;
              break;
            case 'GEN_ORG_LS2':
              out.name = organization.organization.licenses.in2;
              break;
            case 'GEN_ORG_LS3':
              out.name = organization.organization.licenses.in3;
              break;
            case 'GEN_ORG_LS4':
              out.name = organization.organization.licenses.in4;
              break;
            case 'GEN_ORG_LS5':
              out.name = organization.organization.licenses.in5;
              break;
            case 'GEN_ORG_LS6':
              out.name = organization.organization.licenses.in6;
              break;
            case 'GEN_ORG_LI1':
              out.name = organization.organization.licenses.id1;
              break;
            case 'GEN_ORG_LI2':
              out.name = organization.organization.licenses.id2;
              break;
            case 'GEN_ORG_LI3':
              out.name = organization.organization.licenses.id3;
              break;
            case 'GEN_ORG_LI4':
              out.name = organization.organization.licenses.id4;
              break;
            case 'GEN_ORG_LI5':
              out.name = organization.organization.licenses.id5;
              break;
            case 'GEN_ORG_LI6':
              out.name = organization.organization.licenses.id6;
              break;
            case 'GEN_USR_OWN':
              out.name = `${owner.user.firstName} ${owner.user.lastName}`;
              break;
            case 'GEN_USR_LS1':
              out.name = owner.user.licenses.in1;
              break;
            case 'GEN_USR_LS2':
              out.name = owner.user.licenses.in2;
              break;
            case 'GEN_USR_LS3':
              out.name = owner.user.licenses.in3;
              break;
            case 'GEN_USR_LS4':
              out.name = owner.user.licenses.in4;
              break;
            case 'GEN_USR_LS5':
              out.name = owner.user.licenses.in5;
              break;
            case 'GEN_USR_LS6':
              out.name = owner.user.licenses.in6;
              break;
            case 'GEN_USR_LI1':
              out.name = owner.user.licenses.id1;
              break;
            case 'GEN_USR_LI2':
              out.name = owner.user.licenses.id2;
              break;
            case 'GEN_USR_LI3':
              out.name = owner.user.licenses.id3;
              break;
            case 'GEN_USR_LI4':
              out.name = owner.user.licenses.id4;
              break;
            case 'GEN_USR_LI5':
              out.name = owner.user.licenses.id5;
              break;
            case 'GEN_USR_LI6':
              out.name = owner.user.licenses.id6;
              break;
            case 'GEN_USR_PA1':
              if (partners && partners.length > 0) {
                out.name = `${partners[0].user.firstName} ${partners[0].user.lastName}`;
              }
              break;
            case 'GEN_USR_PO1':
              if (partners && partners.length > 0) {
                out.name = organization.partnersAttributes[partners[0].id].companyName;
              }
              break;
            case 'GEN_USR_PA2':
              if (partners && partners.length > 1) {
                out.name = `${partners[1].user.firstName} ${partners[1].user.lastName}`;
              }
              break;
            case 'GEN_USR_PO2':
              if (partners && partners.length > 0) {
                out.name = organization.partnersAttributes[partners[1].id].companyName;
              }
              break;
            case 'GEN_USR_PA3':
              if (partners && partners.length > 2) {
                out.name = `${partners[2].user.firstName} ${partners[2].user.lastName}`;
              }
              break;
            case 'GEN_USR_PO3':
              if (partners && partners.length > 0) {
                out.name = organization.partnersAttributes[partners[2].id].companyName;
              }
              break;
            case 'GEN_USR_AS_PA1':
              if (accountsAsPartners && accountsAsPartners.length > 0) {
                out.name = `${accountsAsPartners[0].user.firstName} ${accountsAsPartners[0].user.lastName}`;
              }
              break;
            case 'GEN_USR_AS_PA2':
              if (accountsAsPartners && accountsAsPartners.length > 1) {
                out.name = `${accountsAsPartners[1].user.firstName} ${accountsAsPartners[1].user.lastName}`;
              }
              break;
            case 'GEN_USR_AS_PA3':
              if (accountsAsPartners && accountsAsPartners.length > 2) {
                out.name = `${accountsAsPartners[2].user.firstName} ${accountsAsPartners[2].user.lastName}`;
              }
              break;
            default:
              break;
          }
        }
        return out;
      };
      if (splits && splits.length) {
        splits.forEach((split) => {
          const out = replaceGeneric(split);
          if (out.splits && out.splits.length) {
            out.splits = mergeGenerics(
              out.splits,
              enterprise,
              group,
              organization,
              owner,
              partners,
              accountsAsPartners
            );
          }
          output.push(out);
        });
      }
      return output;
    };
    return {
      createCommission: (doc) => dataService.createDocument(Commission, doc),
      readCommission: (doc) => dataService.readDocument(Commission, doc),
      updateCommission: (doc) => dataService.updateDocument(Commission, doc),
      deleteCommission: (doc) => dataService.deleteDocument(Commission, doc),
      mergeGenerics
    };
  })
  .service(
    'commissionsService',
    ($http, $rootScope, CacheFactory, dataService, Commission, COMMISSION) => {
      let cache;
      if (!CacheFactory.get(COMMISSION.CACHE.NAME)) {
        cache = CacheFactory(COMMISSION.CACHE.NAME, COMMISSION.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || COMMISSION.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params),
            params?.ignoreCache === true,
            Commission.build,
            $http.get,
            COMMISSION.API.AVAILABLE,
            { params }
          )
      };
    }
  )
  .constant('COMMISSION', {
    API: {
      AVAILABLE: '/api/v1/commissions/available/'
    },
    PAYEE: [
      { id: 'GEN_ORG_ENT', name: 'Generic Enterprise', email: 'ORGANIZATION', image: '' },
      { id: 'GEN_ORG_GRP', name: 'Generic Group', email: 'ORGANIZATION', image: '' },
      { id: 'GEN_ORG_BRN', name: 'Generic Branch', email: 'ORGANIZATION', image: '' },
      { id: 'GEN_ORG_CUR', name: 'Generic Organization', email: 'ORGANIZATION', image: '' },
      {
        id: 'GEN_ORG_LS1',
        name: 'Generic Organization Institution 1',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LI1',
        name: 'Generic Organization License 1',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LS2',
        name: 'Generic Organization Institution 2',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LI2',
        name: 'Generic Organization License 2',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LS3',
        name: 'Generic Organization Institution 3',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LI3',
        name: 'Generic Organization License 3',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LS4',
        name: 'Generic Organization Institution 4',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LI4',
        name: 'Generic Organization License 4',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LS5',
        name: 'Generic Organization Institution 5',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LI5',
        name: 'Generic Organization License 5',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LS6',
        name: 'Generic Organization Institution 6',
        email: 'ORGANIZATION',
        image: ''
      },
      {
        id: 'GEN_ORG_LI6',
        name: 'Generic Organization License 6',
        email: 'ORGANIZATION',
        image: ''
      },
      { id: 'GEN_USR_OWN', name: 'Generic Deal Owner', email: 'USER', image: '' },
      { id: 'GEN_USR_LS1', name: 'Generic Deal Owner Institution 1', email: 'USER', image: '' },
      { id: 'GEN_USR_LI1', name: 'Generic Deal Owner License 1', email: 'USER', image: '' },
      { id: 'GEN_USR_LS2', name: 'Generic Deal Owner Institution 2', email: 'USER', image: '' },
      { id: 'GEN_USR_LI2', name: 'Generic Deal Owner License 2', email: 'USER', image: '' },
      { id: 'GEN_USR_LS3', name: 'Generic Deal Owner Institution 3', email: 'USER', image: '' },
      { id: 'GEN_USR_LI3', name: 'Generic Deal Owner License 3', email: 'USER', image: '' },
      { id: 'GEN_USR_LS4', name: 'Generic Deal Owner Institution 4', email: 'USER', image: '' },
      { id: 'GEN_USR_LI4', name: 'Generic Deal Owner License 4', email: 'USER', image: '' },
      { id: 'GEN_USR_LS5', name: 'Generic Deal Owner Institution 5', email: 'USER', image: '' },
      { id: 'GEN_USR_LI5', name: 'Generic Deal Owner License 5', email: 'USER', image: '' },
      { id: 'GEN_USR_LS6', name: 'Generic Deal Owner Institution 6', email: 'USER', image: '' },
      { id: 'GEN_USR_LI6', name: 'Generic Deal Owner License 6', email: 'USER', image: '' },
      { id: 'GEN_USR_PA1', name: 'Generic Deal Partner 1', email: 'PARTNER', image: '' },
      {
        id: 'GEN_USR_PO1',
        name: 'Generic Deal Partner 1 Organisation',
        email: 'PARTNER',
        image: ''
      },
      { id: 'GEN_USR_PA2', name: 'Generic Deal Partner 2', email: 'PARTNER', image: '' },
      {
        id: 'GEN_USR_PO2',
        name: 'Generic Deal Partner 2 Organisation',
        email: 'PARTNER',
        image: ''
      },
      { id: 'GEN_USR_PA3', name: 'Generic Deal Partner 3', email: 'PARTNER', image: '' },
      {
        id: 'GEN_USR_PO3',
        name: 'Generic Deal Partner 3 Organisation',
        email: 'PARTNER',
        image: ''
      },
      {
        id: 'GEN_USR_AS_PA1',
        name: 'Generic Deal User as Partner 1',
        email: 'USER_AS_PARTNER',
        image: ''
      },
      {
        id: 'GEN_USR_AS_PA2',
        name: 'Generic Deal User as Partner 2',
        email: 'USER_AS_PARTNER',
        image: ''
      },
      {
        id: 'GEN_USR_AS_PA3',
        name: 'Generic Deal User as Partner 3',
        email: 'USER_AS_PARTNER',
        image: ''
      }
    ],
    CACHE: {
      NAME: 'commissionsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
